import { useEffect, useState } from 'react';
import {
    Sync,
    SyncProblem,
    Description,
    SyncDisabled,
} from '@mui/icons-material';
import { BackOfficeSyncIconConfig } from 'types';
import { Tooltip, Icon } from '@mui/material';

export interface DeviceBackOfficeSyncIconProps {
    iconConfig: BackOfficeSyncIconConfig;
}

export const DeviceBackOfficeSyncIcon = ({
    iconConfig,
}: DeviceBackOfficeSyncIconProps) => {
    const [iconElem, setIconElem] = useState<JSX.Element>(<div />);

    useEffect(() => {
        if (iconConfig) {
            setMuiIcon(iconConfig.backoffice_icon);
        }
    }, [iconConfig]);

    const setMuiIcon = (icon: string) => {
        if (icon === 'sync_disabled')
            setIconElem(<SyncDisabled data-testid="SyncDisabledIcon" />);
        else if (icon === 'sync') setIconElem(<Sync data-testid="SyncIcon" />);
        else if (icon === 'sync_problem')
            setIconElem(<SyncProblem data-testid="SyncProblemIcon" />);
        else if (icon === 'description')
            setIconElem(<Description data-testid="DescriptionIcon" />);
        else setIconElem(<div />);
    };

    return (
        <div data-testid="DeviceBackOfficeSyncIcon">
            <Tooltip title={iconConfig.bo_sync_msg}>
                <Icon sx={{ color: iconConfig.color }}>{iconElem}</Icon>
            </Tooltip>
        </div>
    );
};
